/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

import { withBrandIcon, type BrandIcon } from '../../../icons/with-brand-icon';

const OfficialIcon = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "@atlassian/logo-third-party/salesforce" */ '@atlassian/logo-third-party/salesforce'
		).then((m) => m.SalesforceIcon),
	{ moduleId: '@atlassian/logo-third-party/salesforce' },
);

const LazyForgeUnitoSalesforceProdIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-unito-salesforce-prod" */ './utils').then(
			(m) => m.ForgeUnitoSalesforceProdIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-unito-salesforce-prod/icon' },
);

const LazyForgeUnitoSalesforceProdSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-unito-salesforce-prod-search-result" */ './utils').then(
			(m) => m.ForgeUnitoSalesforceProdSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-unito-salesforce-prod/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const ForgeUnitoSalesforceProdIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyForgeUnitoSalesforceProdIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'small',
);

export const ForgeUnitoSalesforceProdSearchResultIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyForgeUnitoSalesforceProdSearchResultIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'medium',
);
